import React from "react"

function CookiesSEO() {
  return <meta name="description" content="Cookies Nabestaandenloket website" />
}

export default CookiesSEO
